import { render, staticRenderFns } from "./MailBtn.vue?vue&type=template&id=1c69a1f8&scoped=true&"
import script from "./MailBtn.vue?vue&type=script&lang=js&"
export * from "./MailBtn.vue?vue&type=script&lang=js&"
import style0 from "./MailBtn.vue?vue&type=style&index=0&id=1c69a1f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c69a1f8",
  null
  
)

export default component.exports